import ethereum from '../assets/chains/ethereum.png';
import avalanche from '../assets/chains/avalanche.png';
import optimism from '../assets/chains/optimism.png';
import arbitrum from '../assets/chains/arbitrum.png';
import base from '../assets/chains/base.png';
import polygon from '../assets/chains/polygon.png';
import unichain from '../assets/chains/unichain.png';
import linea from '../assets/chains/linea.png';
import sonic from '../assets/chains/sonic.png';
import { SupportedChainId } from './cctp/chains';

export const CHAIN_IMAGES = {
  [SupportedChainId.ETHEREUM]: ethereum,
  [SupportedChainId.AVALANCHE]: avalanche,
  [SupportedChainId.OPTIMISM]: optimism,
  [SupportedChainId.ARBITRUM]: arbitrum,
  [SupportedChainId.BASE]: base,
  [SupportedChainId.POLYGON]: polygon,
  [SupportedChainId.UNICHAIN]: unichain,
  [SupportedChainId.LINEA]: linea,
  [SupportedChainId.SONIC]: sonic,
};
